import classNames from 'classnames';
import Calendar from 'input-moment/lib/calendar';
import Time from 'input-moment/lib/time';
import omit from 'lodash/omit';
import moment from 'moment';
import * as T from 'prop-types';
import React, {Component} from 'react';
import {Button} from '../../buttons/Button/index';
import {I18nMessage} from '../../I18nMessage/index';

export class InputMomentComponent extends Component {
  static propTypes = {
    className: T.string,
    prevMonthIcon: T.string,
    nextMonthIcon: T.string,
    includeDate: T.bool,
    includeTime: T.bool,
    moment: T.instanceOf(moment).isRequired,
    minStep: T.number,
    hourStep: T.number,
    onChange: T.func,
    onSave: T.func,
  };

  static defaultProps = {
    prevMonthIcon: 'ion-ios-arrow-left',
    nextMonthIcon: 'ion-ios-arrow-right',
    minStep: 1,
    hourStep: 1,
  };

  static excludedProps = Object.keys(InputMomentComponent.propTypes);

  constructor(props) {
    super(props);

    this.state = {
      tab: +!this.props.includeDate, // render Time tab if includeDate = false
    };
    this.handleClickTab0 = this.handleClickTab0.bind(this);
    this.handleClickTab1 = this.handleClickTab1.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  handleClickTab0(e) {
    this.handleClickTab(e, 0);
  }

  handleClickTab1(e) {
    this.handleClickTab(e, 1);
  }

  handleClickTab(e, tab) {
    e.preventDefault();
    this.setState({tab});
  }

  handleSave(e) {
    e.preventDefault();
    if (this.props.onSave) this.props.onSave();
  }

  render() {
    const {tab} = this.state;

    return (
      <div
        className={classNames("InputMoment", this.props.className)}
        {...omit(this.props, InputMomentComponent.excludedProps)}
      >
        {this.props.includeDate && this.props.includeTime ? (
          <div className="InputMoment__options">
            <Button
              className={classNames('InputMoment__optionsButton', {
                InputMoment__optionsButton_active: tab === 0,
              })}
              leftIconClass="ion-calendar"
              label={<I18nMessage message="default.date.label" />}
              onClick={this.handleClickTab0}
            />
            <Button
              className={classNames('InputMoment__optionsButton', {
                InputMoment__optionsButton_active: tab === 1,
              })}
              leftIconClass="ion-clock"
              label={<I18nMessage message="default.time.label" />}
              onClick={this.handleClickTab1}
            />
          </div>
        ) : null}

        <div className="InputMoment__tabs">
          <Calendar
            className={classNames("InputMoment__tab", {
              InputMoment__tab_active: tab === 0,
            })}
            moment={this.props.moment}
            onChange={this.props.onChange}
            prevMonthIcon={this.props.prevMonthIcon}
            nextMonthIcon={this.props.nextMonthIcon}
          />
          <Time
            className={classNames("InputMoment__tab", {
              InputMoment__tab_active: tab === 1,
            })}
            moment={this.props.moment}
            minStep={this.props.minStep}
            hourStep={this.props.hourStep}
            onChange={this.props.onChange}
          />
        </div>

        {this.props.onSave ? (
          <Button
            className="InputMoment__saveButton"
            leftIconClass="ion-checkmark"
            label={<I18nMessage message="default.save.label" />}
            onClick={this.handleSave}
          />
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/temporal/InputMoment/InputMomentComponent.js